import React, {useState, useEffect, Fragment} from 'react';

import './VideoCallButtonFlotante.scss';
import camera_button from '../../images/white_camera.svg';
import { VIDEO_CALL_LINK } from '../../utils/constants';
import { popUpWin } from '../../utils/helpers';

const openPopUp = () => {
  popUpWin(VIDEO_CALL_LINK, 700, 700);
};

const VideoCallButtonFlotante = ({ text, isSummary }) => {
  const timeFrameEnable = 7000;
  const timeFrameDisable = 60000;
  const [popUpMessageVisible, setPopUpMessageVisible] = useState(true);
  const [timerPopUpVisible, setTimerPopUpVisible] = useState(timeFrameEnable);

  const closePopUpMessage = () => {
    setPopUpMessageVisible(false);
    setTimerPopUpVisible(timeFrameEnable);
  }

  useEffect(() => {
    if (popUpMessageVisible) {
      setTimeout(() => {
        setPopUpMessageVisible(false);
      }, timeFrameEnable+1000);

      setTimerPopUpVisible(timeFrameEnable);
      const interval = setInterval(() => {
        setTimerPopUpVisible(prevState => prevState -1000);
      }, 1000);
  
      return () => clearInterval(interval);
    } else {
      setTimeout(() => {
        setPopUpMessageVisible(true);
      }, timeFrameDisable);
      setTimerPopUpVisible(timeFrameEnable);
    }
  }, [popUpMessageVisible]);

  return (
    <Fragment>
      {popUpMessageVisible && <button className="video-call-popup-message-close" onClick={closePopUpMessage}></button> }
      <button className='expo-videocall' onClick={openPopUp} >
        {popUpMessageVisible && 
          <div className="video-call-popup-message">
            <p className="video-call-popup-message-title">¿Querés ver tu chuzo en vivo?</p>
            <p className="video-call-popup-message-text">Realizá una video llamada.</p>
            <div className="video-call-popup-message-timer" style={{'width': ((100 / 7000) * timerPopUpVisible)+'%' }}></div>
          </div>
        }
        
        <div className="video-call-button__container-flotante"
          style={{
            '--margin-container': isSummary && '5px',
            '--width-button': isSummary && '220px'
          }}>
          <div className="video-call-button__elements-flotante">
            <img className="video-call-button__camera-flotante" src={camera_button} alt="Videocamara" />
            <p className="video-call-button__text">{text}</p>
          </div>
        </div>
      </button>
    </Fragment>
    
  );
}

export default VideoCallButtonFlotante;
